import { Component, OnInit, Inject, Optional } from '@angular/core';
import { OfferedService } from 'src/shared/api';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filter, takeUntil } from 'rxjs/operators';
import { offeredServiceFormConfig } from '../offered-service.component';

@Component({
	selector: 'rpshared-offered-service-dialog',
	templateUrl: './offered-service-dialog.component.html',
})
export class OfferedServiceDialogComponent extends SelfDestruct
	implements OnInit {
	// CVA components can only be listened to through a form control
	control = new FormControl('') as FormControl;

	group = this.fb.group(offeredServiceFormConfig) as FormGroup;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		@Optional()
		private readonly offeredService: OfferedService,
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		this.control.valueChanges
			.pipe(filter(Boolean), takeUntil(this.destroyed))
			.subscribe((v) => this.group.setValue(v));

		if (this.offeredService) {
			this.control.setValue(this.offeredService);
		}
	}
}
